const translations = {
  title: "Staff Attendance & Salary",
  subtitle: "Track attendance, salaries, advance payments, and worker settlements.",
  // Tabs
  tab_attendance: "Attendance",
  tab_salary: "Salary Rules",
  tab_transactions: "Transactions",
  tab_settlements: "Settlements",
  tab_goldBook: "Gold Book",
  // Attendance
  attendance: "Attendance",
  markAttendance: "Mark Attendance",
  attendanceDate: "Date",
  attendanceStatus: "Status",
  status_present: "Present",
  status_absent: "Absent",
  status_halfDay: "Half Day",
  status_leave: "Leave",
  workerName: "Worker Name",
  arrivalTime: "Arrived",
  departureTime: "Left",
  notes: "Notes",
  // Salary
  salaryRules: "Salary Rules",
  addSalaryRule: "Add Salary Rule",
  dailyWage: "Daily Wage (₹)",
  monthlyFixed: "Monthly Fixed (₹)",
  effectiveFrom: "Effective From",
  ruleType: "Rule Type",
  type_daily: "Daily Wage",
  type_monthly: "Monthly Fixed",
  type_piece_rate: "Piece Rate",
  // Transactions
  transactions: "Transactions",
  addTransaction: "Add Transaction",
  transactionType: "Type",
  type_withdrawal: "Withdrawal",
  type_loan: "Loan",
  type_salary_advance: "Salary Advance",
  type_gold_advance: "Gold Advance",
  type_wastage_return: "Wastage Gold Return",
  withdrawalAmount: "Amount (₹)",
  loanAmount: "Loan Amount (₹)",
  advanceAmount: "Advance Amount (₹)",
  goldAdvanceMg: "Gold Advance (mg)",
  purity: "Purity",
  repaymentDate: "Repayment Date",
  reason: "Reason",
  // Settlement
  settlements: "Settlements",
  newSettlement: "New Settlement",
  settlementDate: "Settlement Date",
  settlementPeriod: "Period",
  presentDays: "Present Days",
  halfDays: "Half Days",
  totalEarned: "Total Earned (₹)",
  deductions: "Deductions (₹)",
  loanRepaid: "Loan Repaid (₹)",
  netPayable: "Net Payable (₹)",
  settlementNotes: "Notes",
  closeSettlement: "Close & Settle",
  // Gold Book
  goldBook: "Worker Gold Book",
  goldGiven: "Gold Given (mg)",
  goldReturned: "Gold Returned (mg)",
  goldBalance: "Gold Balance (mg)",
  goldEntry: "Gold Book Entry",
  entryType: "Type",
  entry_given: "Gold Given",
  entry_return: "Gold Return",
  entryDate: "Date",
  entryWeight: "Weight (mg)",
  entryPurity: "Purity",
  entryNotes: "Notes",
  // Summary
  totalWorkers: "Total Workers",
  presentToday: "Present Today",
  absentToday: "Absent Today",
  pendingSettlements: "Pending Settlements",
  // Empty states
  noWorkers: "No workers added yet.",
  noAttendance: "No attendance records.",
  noTransactions: "No transactions yet.",
  noSettlements: "No settlements yet.",
  // Columns
  col_worker: "Worker",
  col_date: "Date",
  col_status: "Status",
  col_type: "Type",
  col_amount: "Amount",
  col_notes: "Notes",
  col_action: "Action",
  // Stay tracking
  arrivedAt: "Arrived At",
  goneHomeAt: "Left At",
  markArrived: "Mark Arrived",
  markGoneHome: "Mark Gone Home",
  currentlyInShop: "Currently in Shop",
};

export default translations;
